export const icon = (name, size) => {
    switch (name) {
        case 'arrow-right':
            return (
                <svg
                    className="baseocom-inline-block"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width={size ? size : '24'}
                    height={size ? size : '24'}
                >
                    <path d="m16.172 11-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2h12.172Z" />
                </svg>
            )
        case 'address':
            return (
                <svg
                    className="baseocom-inline-block"
                    role="img"
                    aria-label="adresse"
                    focusable="false"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <title>adresse</title>
                    <path d="M12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0L12 23.728zm4.95-7.778a7 7 0 1 0-9.9 0L12 20.9l4.95-4.95zM12 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"></path>
                </svg>
            )
        case 'checked':
            return (
                <svg
                    className="baseocom-inline-block"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path d="m10 15.172 9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414 4.95 4.95Z" />
                </svg>
            )
        case 'document-model':
            return (
                <svg
                    className="baseocom-inline-block"
                    aria-hidden="true"
                    focusable="false"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path d="M19 22H5a3 3 0 0 1-3-3V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v12h4v4a3 3 0 0 1-3 3zm-1-5v2a1 1 0 0 0 2 0v-2h-2zm-2 3V4H4v15a1 1 0 0 0 1 1h11zM6 7h8v2H6V7zm0 4h8v2H6v-2zm0 4h5v2H6v-2z"></path>
                </svg>
            )
        case 'video':
            return (
                <svg
                    className="baseocom-inline-block"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM10.622 8.415l4.879 3.252a.4.4 0 0 1 0 .666l-4.88 3.252a.4.4 0 0 1-.621-.332V8.747a.4.4 0 0 1 .622-.332Z" />
                </svg>
            )
        case 'back':
            return (
                <svg
                    className="baseocom-inline-block"
                    aria-hidden="true"
                    focusable="false"
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                >
                    <path d="M5.828 7l2.536 2.536L6.95 10.95 2 6l4.95-4.95 1.414 1.414L5.828 5H13a8 8 0 1 1 0 16H4v-2h9a6 6 0 1 0 0-12H5.828z"></path>
                </svg>
            )
        case 'simulator':
            return (
                <svg
                    className="baseocom-inline-block"
                    aria-hidden="true"
                    focusable="false"
                    class="fr-mb-1w sp-icon sp-icon-ri-equalizer-line"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path d="M6.17 18a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2v-2h4.17zm6-7a3.001 3.001 0 0 1 5.66 0H22v2h-4.17a3.001 3.001 0 0 1-5.66 0H2v-2h10.17zm-6-7a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2V4h4.17zM9 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"></path>
                </svg>
            )
        case 'help':
            return (
                <svg
                    className="baseocom-inline-block"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm-1-7v2h2v-2h-2Zm2-1.645A3.502 3.502 0 0 0 12 6.5a3.501 3.501 0 0 0-3.433 2.813l1.962.393A1.5 1.5 0 1 1 12 11.5a1 1 0 0 0-1 1V14h2v-.645Z" />
                </svg>
            )
        case 'help-me':
            return (
                <svg
                    className="baseocom-inline-block"
                    aria-hidden="true"
                    focusable="false"
                    height="32"
                    viewBox="0 0 24 24"
                    width="32"
                >
                    <path d="M19.938 8H21a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1.062A8.001 8.001 0 0 1 12 23v-2a6 6 0 0 0 6-6V9A6 6 0 1 0 6 9v7H3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.062a8.001 8.001 0 0 1 15.876 0zM3 10v4h1v-4H3zm17 0v4h1v-4h-1zM7.76 15.785l1.06-1.696A5.972 5.972 0 0 0 12 15a5.972 5.972 0 0 0 3.18-.911l1.06 1.696A7.963 7.963 0 0 1 12 17a7.963 7.963 0 0 1-4.24-1.215z"></path>
                </svg>
            )
        case 'arrow-down':
            return (
                <svg
                    className="baseocom-inline-block"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                >
                    <path d="M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6Zm11-3v8h-2V6.413l-7.793 7.794-1.414-1.414L17.585 5H13V3h8Z" />
                </svg>
            )
        case 'chevron-down':
            return (
                <svg
                    className="baseocom-inline-block"
                    aria-hidden="true"
                    focusable="false"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                >
                    <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"></path>
                </svg>
            )
        case 'email':
            return (
                <svg
                    className="baseocom-inline-block"
                    role="img"
                    aria-label="courriel"
                    focusable="false"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <title>Courriel</title> <path fill="none" d="M0 0h24v24H0z"></path>{' '}
                    <path d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm17 4.238l-7.928 7.1L4 7.216V19h16V7.238zM4.511 5l7.55 6.662L19.502 5H4.511z"></path>{' '}
                </svg>
            )
        case 'external-link':
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="baseocom-flex-shrink-0 baseocom-inline-block"
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                >
                    <path d="M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6Zm11-3v8h-2V6.413l-7.793 7.794-1.414-1.414L17.585 5H13V3h8Z" />
                </svg>
            )
        case 'magnifying-glass':
            return (
                <svg
                    className="baseocom-inline-block"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width={size ? size : '24'}
                    height={size ? size : '24'}
                >
                    <path d="m18.031 16.617 4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617Zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15Z" />
                </svg>
            )
        case 'close':
            return (
                <svg
                    className="baseocom-inline-block"
                    aria-hidden="true"
                    focusable="false"
                    viewBox="0 0 24 24"
                    width={size ? size : '24'}
                    height={size ? size : '24'}
                >
                    <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"></path>
                </svg>
            )
        case 'form':
            return (
                <svg
                    className="baseocom-inline-block"
                    aria-hidden="true"
                    focusable="false"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path d="M20 2c.552 0 1 .448 1 1v3.757l-2 2V4H5v16h14v-2.758l2-2V21c0 .552-.448 1-1 1H4c-.552 0-1-.448-1-1V3c0-.552.448-1 1-1h16zm1.778 6.808l1.414 1.414L15.414 18l-1.416-.002.002-1.412 7.778-7.778zM13 12v2H8v-2h5zm3-4v2H8V8h8z"></path>
                </svg>
            )
        case 'checkbox-circle':
            return (
                <svg
                    className="baseocom-inline-block"
                    aria-hidden="true"
                    focusable="false"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z"></path>
                </svg>
            )
        case 'teleservice':
            return (
                <svg
                    className="baseocom-inline-block"
                    aria-hidden="true"
                    focusable="false"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path d="M16.05 12.05L21 17l-4.95 4.95-1.414-1.414 2.536-2.537L4 18v-2h13.172l-2.536-2.536 1.414-1.414zm-8.1-10l1.414 1.414L6.828 6 20 6v2H6.828l2.536 2.536L7.95 11.95 3 7l4.95-4.95z"></path>
                </svg>
            )
        case 'research-tool':
            return (
                <svg
                    className="baseocom-inline-block"
                    aria-hidden="true"
                    focusable="false"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm4.5-12.5L14 14l-6.5 2.5L10 10l6.5-2.5zM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"></path>
                </svg>
            )
        case 'phone':
            return (
                <svg
                    className="baseocom-inline-block"
                    role="img"
                    aria-label="téléphone"
                    focusable="false"
                    viewBox="0 0 24 24"
                    width="26"
                    height="26"
                >
                    <title>Téléphone</title> <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M9.366 10.682a10.556 10.556 0 0 0 3.952 3.952l.884-1.238a1 1 0 0 1 1.294-.296 11.422 11.422 0 0 0 4.583 1.364 1 1 0 0 1 .921.997v4.462a1 1 0 0 1-.898.995c-.53.055-1.064.082-1.602.082C9.94 21 3 14.06 3 5.5c0-.538.027-1.072.082-1.602A1 1 0 0 1 4.077 3h4.462a1 1 0 0 1 .997.921A11.422 11.422 0 0 0 10.9 8.504a1 1 0 0 1-.296 1.294l-1.238.884zm-2.522-.657l1.9-1.357A13.41 13.41 0 0 1 7.647 5H5.01c-.006.166-.009.333-.009.5C5 12.956 11.044 19 18.5 19c.167 0 .334-.003.5-.01v-2.637a13.41 13.41 0 0 1-3.668-1.097l-1.357 1.9a12.442 12.442 0 0 1-1.588-.75l-.058-.033a12.556 12.556 0 0 1-4.702-4.702l-.033-.058a12.442 12.442 0 0 1-.75-1.588z"></path>{' '}
                </svg>
            )
        case 'table':
            return (
                <svg
                    className="baseocom-inline-block"
                    aria-hidden="true"
                    focusable="false"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path d="M4 8h16V5H4v3zm10 11v-9h-4v9h4zm2 0h4v-9h-4v9zm-8 0v-9H4v9h4zM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"></path>
                </svg>
            )
        case 'time-slots':
            return (
                <svg
                    className="baseocom-inline-block"
                    role="img"
                    aria-label="horaires"
                    focusable="false"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <title>horaires</title> <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-8h4v2h-6V7h2v5z"></path>{' '}
                </svg>
            )
        case 'warning':
            return (
                <svg
                    className="baseocom-inline-block"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="#FFF"
                    viewBox="0 0 24 24"
                >
                    <path d="M19.5,2.5h-15c-1.1,0-2,0.9-2,2v15c0,1.1,0.9,2,2,2h15c1.1,0,2-0.9,2-2v-15C21.5,3.4,20.6,2.5,19.5,2.5z M13,17h-2v-6h2V17z M13,9h-2V7h2V9z" />
                </svg>
            )
        case 'website':
            return (
                <svg
                    className="baseocom-inline-block"
                    role="img"
                    aria-label="site internet"
                    focusable="false"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <title>site internet</title>{' '}
                    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-2.29-2.333A17.9 17.9 0 0 1 8.027 13H4.062a8.008 8.008 0 0 0 5.648 6.667zM10.03 13c.151 2.439.848 4.73 1.97 6.752A15.905 15.905 0 0 0 13.97 13h-3.94zm9.908 0h-3.965a17.9 17.9 0 0 1-1.683 6.667A8.008 8.008 0 0 0 19.938 13zM4.062 11h3.965A17.9 17.9 0 0 1 9.71 4.333 8.008 8.008 0 0 0 4.062 11zm5.969 0h3.938A15.905 15.905 0 0 0 12 4.248 15.905 15.905 0 0 0 10.03 11zm4.259-6.667A17.9 17.9 0 0 1 15.973 11h3.965a8.008 8.008 0 0 0-5.648-6.667z"></path>{' '}
                </svg>
            )

        case 'list':
            return (
                <svg
                    className="baseocom-inline-block"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path d="M3 4h18v2H3V4Zm0 15h14v2H3v-2Zm0-5h18v2H3v-2Zm0-5h14v2H3V9Z" />
                </svg>
            )
        case 'plus':
            return (
                <svg
                    className="baseocom-inline-block"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2h6Z" />
                </svg>
            )
        case 'minus':
            return (
                <svg
                    className="baseocom-inline-block"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path d="M5 11h14v2H5v-2Z" />
                </svg>
            )
        case 'user-search-line':
            return (
                <svg
                    className="baseocom-inline-block"
                    aria-hidden="true"
                    focusable="false"
                    viewBox="0 0 24 24"
                    width="32"
                    height="32"
                >
                    <path d="M12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 8-8zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm9.446 9.032l1.504 1.504-1.414 1.414-1.504-1.504a4 4 0 1 1 1.414-1.414zM18 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"></path>
                </svg>
            )
        case 'user-follow-line':
            return (
                <svg
                    className="baseocom-inline-block"
                    aria-hidden="true"
                    focusable="false"
                    viewBox="0 0 24 24"
                    width="32"
                    height="32"
                >
                    <path d="M14 14.252v2.09A6 6 0 0 0 6 22l-2-.001a8 8 0 0 1 10-7.748zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm5.793 8.914l3.535-3.535 1.415 1.414-4.95 4.95-3.536-3.536 1.415-1.414 2.12 2.121z"></path>
                </svg>
            )
        case 'refresh':
            return (
                <svg
                    className="baseocom-inline-block"
                    width="20px"
                    height="20px"
                    viewBox="0 0 16 16"
                >
                    <g>
                        <path d="M15,6V1.76l-1.7,1.7A7,7,0,1,0,14.92,9H13.51a5.63,5.63,0,1,1-1.2-4.55L10.76,6Z" />
                    </g>
                </svg>
            )
        case 'fax':
            return (
                <svg
                    className="baseocom-inline-block"
                    role="img"
                    aria-label="télécopie"
                    focusable="false"
                    class=" sp-text-color--red fr-mr-1w  sp-icon  sp-icon-ri-printer-line "
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <path d="M6 19H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-3v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2zm0-2v-1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1h2V9H4v8h2zM8 4v3h8V4H8zm0 13v3h8v-3H8zm-3-7h3v2H5v-2z"></path>{' '}
                </svg>
            )

        default:
            null
    }
}
